import { Component,ViewEncapsulation } from '@angular/core';
import { CoreService } from 'src/app/services/core/core.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-auth-main',
  templateUrl: './auth-main.component.html',
  styleUrls: ['./auth-main.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class AuthMainComponent {

  readonly iOSAppUrl = environment.iOSAppUrl;
  readonly playStoreUrl = environment.androidAppUrl;

  constructor(
    private readonly coreService: CoreService
  ) { }

  /* Indicates whether the application is running in a mobile context */
  get isMobileApp(): boolean {
    return this.coreService.isMobileApp;
  }

}
